var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-258px h-156px bor-12px b-EFEFEF p-r o-h"},[_c('div',{staticClass:"w-100 h-22px b-D8D8D8 t-31px p-a"})])}]

export { render, staticRenderFns }